var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.oidcIsAuthenticated)?_c('div',{staticClass:"protected"},[_c('h1',[_vm._v("This route requires authentication")]),_c('SignedInUser')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }